export default "__VITE_ASSET__0eece3ac__"